import { Helmet } from "react-helmet";

const SEO = ({ title, description, keywords, schema, canonicalUrl, image }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    {keywords && <meta name="keywords" content={keywords} />}
    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

    {/* Open Graph */}
    <meta property="og:type" content="website" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image || "https://mamshospitals.com/MAMS-Logo.png"} />
    {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
    <meta property="og:site_name" content="MAMS Hospitals" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image || "https://mamshospitals.com/MAMS-Logo.png"} />

    {schema && (
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    )}
  </Helmet>
);

export default SEO;